<template>
    <div class="container-fluid">
        <Breadcrumb title="Link Groups" button-url="linkGroupCreate"></Breadcrumb>

        <div class="row" style="position: relative">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="input-group form-group">
                            <div class="form-group" v-if="this.$store.getters.isAdmin">
                                <treeselect placeholder="Search by owner"
                                            v-model="userSearch"
                                            :multiple="false"
                                            :options="userList"
                                            :load-options="loadUserList"
                                            value-format="id"
                                />
                            </div>
                            <div class="form-group">
                                <treeselect v-model="typeSearch" placeholder="Search by type"
                                            :options="groupTypes"
                                            value-format="id"/>
                            </div>
                            <input v-model="groupSearch" type="text" class="form-control form-control-line"
                                   placeholder="Search by group name">
                            <div class="input-group-append">
                                <button v-on:click="search" class="btn btn-info" type="button">Search</button>
                            </div>
                        </div>
                        <div class="form-group mx-sm-3 mb-2">
                                <span>Total:
                                    <span class="label label-info">{{totalItems}}</span>
                                </span>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="col-12" v-if="loading" style="min-height:100px;">
                            <Preloader v-bind:class="{preloader: loading}"></Preloader>
                        </div>
                        <div v-else>
                            <div v-if="groupList.length > 0">
                                <div class="table-responsive">
                                    <table class="table">
                                        <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Name</th>
                                            <th>Type</th>
                                            <th v-if="isAdmin">Owner</th>
                                            <th>Actions</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="(group, index) in groupList" :key="index">
                                            <td class="align-middle">{{group.id}}</td>
                                            <td class="align-middle">{{group.name}}</td>
                                            <td class="align-middle">{{groupTypeLabels[group.type]}}</td>
                                            <td class="align-middle" v-if="isAdmin">{{group.user.username}}</td>
                                            <td class="align-middle">
                                                <router-link :to="{ name: 'linkGroupEdit', params: { id: group.id }}"
                                                             class="btn btn-sm btn-info m-r-10">
                                                    <i class="fa fa-edit"></i> Edit
                                                </router-link>
                                                <router-link
                                                        :to="{ name: 'linkFilter1', params: { groupId: group.id }}"
                                                        class="btn btn-sm btn-warning m-r-10">
                                                    <i class="ti-server"></i> Links
                                                </router-link>
                                                <button type="button" class="btn btn-sm btn-danger"
                                                        @click="deleteGroup(group.id)">
                                                    <i class="fa fa-minus-circle"></i> Delete
                                                </button>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <paginate v-if="pageCount > 1"
                                          v-model="page"
                                          :page-count="pageCount"
                                          :page-range="3"
                                          :margin-pages="2"
                                          :click-handler="getItems"
                                          :prev-text="'Prev'"
                                          :next-text="'Next'"
                                          :container-class="'pagination justify-content-center'"
                                          :page-class="'page-item'"
                                          :page-link-class="'page-link'"
                                          :prev-class="'page-item'"
                                          :prev-link-class="'page-link'"
                                          :next-class="'page-item'"
                                          :next-link-class="'page-link'">
                                </paginate>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Swal from 'sweetalert2';
    import LinkGroupService from '../services/LinkGroupService';
    import Preloader from '../components/Preloader';
    import Breadcrumb from '../components/Breadcrumb';
    import paginateMixin from '../mixins/paginate-mixin';
    import Treeselect from '@riophae/vue-treeselect';
    import UserService from '../services/UserService';
    import {LinkGroupType} from '../constants';

    export default {
        name: 'LinkGroups',
        components: {
            Preloader, Breadcrumb, Treeselect
        },
        mixins: [paginateMixin],
        data() {
            return {
                isAdmin: this.$store.getters.isAdmin,
                groupTypes: LinkGroupType.data,
                groupTypeLabels: LinkGroupType.value,
                groupList: [],
                groupSearch: null,
                userList: null,
                userSearch: null,
                typeSearch: null,
                loading: false,
                totalItems: 0,
                page: 1,
                perPage: paginateMixin.defaultPerPage,
            }
        },
        mounted() {
            this.getItems(this.page = 1);
        },
        methods: {
            getItems: function (pageNum) {
                this.loading = true;
                LinkGroupService.getGroups(pageNum, this.perPage, this.userSearch, this.groupSearch, this.typeSearch).then(response => {
                    this.groupList = response.data['hydra:member'];
                    this.totalItems = response.data['hydra:totalItems'];
                    this.loading = false;
                });
            },
            search: function () {
                this.getItems(this.page = 1);
            },
            deleteGroup(id) {
                Swal({
                    title: 'Are you sure you want to delete?',
                    inputAttributes: {
                        autocapitalize: 'off'
                    },
                    showCancelButton: true,
                    confirmButtonText: 'Confirm',
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return LinkGroupService.deleteGroup(id).then((response) => {
                            if (response.status === 204) {
                                let groupIndex = this.groupList.findIndex(obj => obj.id === id);
                                this.groupList.splice(groupIndex, 1);
                                this.totalItems--;
                            }
                        });
                    },
                    allowOutsideClick: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.value) {
                        Swal(
                            'Deleted successfully!',
                            `Group has been deleted.`,
                            'success'
                        )
                    }
                })
            },
            loadUserList({callback}) {
                UserService.getUserSelect().then(response => {
                    this.userList = response.data['hydra:member'].map(user => {
                        return {id: user.id, label: user.username}
                    });
                    callback();
                });
            }
        },
        computed: {
            pageCount: function () {
                return Math.ceil(this.totalItems / this.perPage);
            }
        }
    }
</script>

<style scoped>

</style>